import React, { Children } from 'react';

import LongForm from '$components/long-form';
import { childByName, nestBrowserMedia } from './utils';

function PullQuote(props: { children: React.ReactNode }) {
  const { children, ...rest } = props;

  if (Children.toArray(children).length !== 2) {
    throw new Error('PullQuote requires two children: a Quote and Content.');
  }

  const quote = childByName(children, 'PullQuoteQuote');
  const content = childByName(children, 'PullQuoteContent');

  return (
    <LongForm {...rest} pullQuote={quote}>
      {content}
    </LongForm>
  );
}

function PullQuoteQuote({ children }: { children: React.ReactNode }) {
  return children;
}
PullQuoteQuote.displayName = 'PullQuoteQuote';

function PullQuoteContent({ children }: { children: React.ReactNode }) {
  return nestBrowserMedia(children);
}
PullQuoteContent.displayName = 'PullQuoteContent';

PullQuote.Quote = PullQuoteQuote;
PullQuote.Content = PullQuoteContent;

export { PullQuote };
